import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { City, Fetchable, Paginated } from "../../interfaces";

export interface CityState {
  allCities: Partial<Fetchable<Paginated<City>>>;
  city: Partial<Fetchable<City>>;
  createdCity: Partial<Fetchable<City | City[]>>;
  updatedCity: Partial<Fetchable<City>>;
  deletedCity: Partial<Fetchable<City>>;
}

const initialState: CityState = {
  allCities: {},
  city: {},
  createdCity: {},
  updatedCity: {},
  deletedCity: {},
};

export const citySlice = createSlice({
  name: "city",
  initialState,
  reducers: {
    setError: (
      state,
      action: PayloadAction<{
        fetchableProp: keyof CityState;
        error: any;
      }>
    ) => {
      state[action.payload.fetchableProp].error = action.payload.error;
    },
    clear: (state, action: PayloadAction<keyof CityState>) => {
      state[action.payload] = {};
    },
    setLoader: (
      state,
      action: PayloadAction<{
        fetchableProp: keyof CityState;
        isLoading: boolean;
      }>
    ) => {
      state[action.payload.fetchableProp].isLoading = action.payload.isLoading;
    },
    // PAGINATED GET
    setPaginatedCities: (state, action: PayloadAction<Paginated<City>>) => {
      state.allCities.data = action.payload;
      state.updatedCity.error = undefined;
    },
    // GET
    setCity: (state, action: PayloadAction<City>) => {
      state.city.data = action.payload;
      state.updatedCity.error = undefined;
    },
    // CREATE
    createCity: (state, action: PayloadAction<City | City[]>) => {
      state.createdCity.data = action.payload;
      state.updatedCity.error = undefined;
    },
    // UPDATE
    updateCity: (state, action: PayloadAction<City>) => {
      state.updatedCity.data = action.payload;
      state.updatedCity.error = undefined;
    },
    // DELETE
    deleteCity: (state, action: PayloadAction<City>) => {
      state.deletedCity.data = action.payload;
      state.updatedCity.error = undefined;
    },
  },
});

const actions = { ...citySlice.actions };

export { actions };
export default citySlice.reducer;
